import React from "react";
import breadcrumbContext from "./context";

const useBreadcrumbs = () => {
	const context = React.useContext(breadcrumbContext);
	if (!context) {
		throw new Error(
			"useBreadcrumbs must be used within a BreadcrumbsProvider"
		);
	}
	return context;
};

export default useBreadcrumbs;
